import { Typography, Box, Grid } from "@material-ui/core";
import React, { Fragment } from "react";
import HeaderPrintAll from "./../../printall/HeaderPrintAll";
import PatientInfoPrintAll from "./../../printall/PatientInfoPrintAll";

const Covid19PrintAll = ({
  allowHeaderPatientInfo,
  patients,
  covidOrderDetails,
}) => {
  return (
    <>
      {covidOrderDetails.data.length > 0 && (
        <Fragment>
          {allowHeaderPatientInfo !== "notallowed" && (
            <>
              <HeaderPrintAll />
              <PatientInfoPrintAll details={patients} />
            </>
          )}
          <Box>
            <Typography
              variant="h6"
              align="center"
              style={{
                fontWeight: "bolder",
                color: "#000",
                textDecoration: "underline",
              }}
            >
              <span
                contentEditable={true}
                suppressContentEditableWarning={true}
              >
                COVID TEST
              </span>
            </Typography>
          </Box>
          <Box>
            {covidOrderDetails.data.map((data, key) => {
              return (
                <Box my={2} key={key}>
                  <Box hidden={!Boolean(parseInt(data.rapid_test))}>
                    <Box display="flex">
                      <Box flexGrow={1}>
                        <Typography
                          variant="subtitle1"
                          style={{ fontWeight: "bolder", color: "#000" }}
                        >
                          RAPID TEST
                        </Typography>
                      </Box>
                    </Box>

                    {Boolean(parseInt(data.is_processed)) && (
                      <Box mt={1}>
                        <Box my={2}>
                          <Box mb={1}>
                            <Typography
                              style={{
                                fontWeight: "bolder",
                                color: "#000",
                              }}
                            >
                              Result
                            </Typography>

                            <Typography
                              style={{
                                fontWeight: "bolder",
                                color: "#000",
                              }}
                            >
                              {data.rapid_test_result}
                            </Typography>
                          </Box>

                          <Box>
                            <Typography
                              style={{
                                fontWeight: "bolder",
                                color: "#000",
                              }}
                            >
                              <b> Remarks </b>
                            </Typography>

                            <Typography
                              style={{
                                fontWeight: "bolder",
                                color: "#000",
                              }}
                            >
                              {data.rapid_test_result_remarks}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    )}
                  </Box>

                  <Box hidden={!Boolean(parseInt(data.antigen_test))}>
                    <Box display="flex">
                      <Box flexGrow={1}>
                        <Typography
                          variant="subtitle1"
                          style={{ fontWeight: "bolder", color: "#000" }}
                        >
                          ANTIGEN TEST
                        </Typography>
                      </Box>
                    </Box>

                    {Boolean(parseInt(data.is_processed)) && (
                      <Box mt={1}>
                        <Box my={2}>
                          <Box mb={1}>
                            <Typography
                              style={{
                                fontWeight: "bolder",
                                color: "#000",
                              }}
                            >
                              Result
                            </Typography>
                            <Typography
                              style={{
                                fontWeight: "bolder",
                                color: "#000",
                              }}
                            >
                              {data.antigen_test_result}
                            </Typography>
                          </Box>

                          <Box>
                            <Typography
                              style={{
                                fontWeight: "bolder",
                                color: "#000",
                              }}
                            >
                              Remarks
                            </Typography>
                            <Typography
                              style={{
                                fontWeight: "bolder",
                                color: "#000",
                              }}
                            >
                              {data.antigen_test_result_remarks}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Box>
              );
            })}
          </Box>
          <Box my={1} align="center">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Box align="center" width={350}>
                  <Box mt={1}>
                    <Typography
                      className={`gtc-uppercase`}
                      variant="subtitle2"
                      style={{ color: "#000", fontWeight: "bolder" }}
                    >
                      {covidOrderDetails.data.length > 0 &&
                        covidOrderDetails.data[0].pathologist}
                    </Typography>
                    <Box borderTop={1}>
                      <b style={{ color: "#000" }}> Pathologist </b>
                    </Box>
                    <Box>
                      <Typography
                        className={`gtc-uppercase`}
                        variant="subtitle2"
                        style={{ color: "#000", fontWeight: "bolder" }}
                      >
                        {covidOrderDetails.data.length > 0 &&
                          covidOrderDetails.data[0].pathologist_lcn}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              {/* <Grid item xs={12} sm={4}>
                <Box align="center" width={350}>
                  <Box mt={1}>
                    <Typography
                      className={`gtc-uppercase`}
                      variant="subtitle2"
                      style={{ color: "#000", fontWeight: "bolder" }}
                    >
                      {covidOrderDetails.data.length > 0 &&
                        covidOrderDetails.data[0].chief_medtech}
                    </Typography>
                    <Box borderTop={1}>
                      <b style={{ color: "#000" }}> Chief Med Technologist </b>
                    </Box>
                    <Box>
                      <Typography
                        className={`gtc-uppercase`}
                        variant="subtitle2"
                        style={{ color: "#000", fontWeight: "bolder" }}
                      >
                        {covidOrderDetails.data.length > 0 &&
                          covidOrderDetails.data[0].chief_medtech_lci}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid> */}

              <Grid item xs={12} sm={6}>
                <Box align="center" width={350}>
                  <Box mt={1}>
                    <Typography
                      className={`gtc-uppercase`}
                      variant="subtitle2"
                      style={{ color: "#000", fontWeight: "bolder" }}
                    >
                      <span
                        contentEditable={true}
                        suppressContentEditableWarning={true}
                      >
                        {covidOrderDetails.data.length > 0 &&
                          covidOrderDetails.data[0].medtech}
                      </span>
                    </Typography>
                    <Box borderTop={1}>
                      <b style={{ color: "#000" }}> Medical Technologist </b>
                    </Box>
                    <Box>
                      <Typography
                        className={`gtc-uppercase`}
                        variant="subtitle2"
                        style={{ color: "#000", fontWeight: "bolder" }}
                      >
                        <span
                          contentEditable={true}
                          suppressContentEditableWarning={true}
                        >
                          {covidOrderDetails.data.length > 0 &&
                            covidOrderDetails.data[0].lic_no}
                        </span>
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Fragment>
      )}
    </>
  );
};

export default Covid19PrintAll;
